










import Vue from 'vue';

export default Vue.extend({
  name: "TeenColMain2d",
  data: () => {
    return {};
  },
});
